import css from './Card.module.css';

type CardProps = {
  flexDirection: string;
  secondaryClass?: string;
  title?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

const Card = ({
  flexDirection,
  secondaryClass,
  title,
  onClick,
  children,
}: CardProps) => {
  let classes = css.card;
  if (flexDirection === 'column') {
    classes += ' ' + css.column;
  }
  if (secondaryClass !== undefined) {
    classes += ' ' + secondaryClass;
  }

  const titleDisplay =
    title !== undefined ? (
      <header className={css.title}>{title}</header>
    ) : (
      <></>
    );

  return (
    <div className={classes} onClick={onClick}>
      {titleDisplay}
      {children}
    </div>
  );
};

export default Card;
